import {
  PERSON_RELATIONSHIP_EMPLOYEE,
  PERSON_RELATIONSHIP_SPOUSE,
  PERSON_RELATIONSHIP_CHILD,
} from '@hixme/person-relationships'

export const RelationshipSortOrder = {
  [PERSON_RELATIONSHIP_EMPLOYEE.toUpperCase()]: 100,
  [PERSON_RELATIONSHIP_SPOUSE.toUpperCase()]: 90,
  DOMESTIC_PARTNER: 80,
  [PERSON_RELATIONSHIP_CHILD.toUpperCase()]: 70,
  CHILD_OF_DOMESTIC_PARTNER: 60,
}

export const PERSON_RELATIONSHIP_CHILD_OF_DOMESTIC_PARTNER = 'CHILD_OF_DOMESTIC_PARTNER'

export const CHILD_NOTICE = `The information you have provided results in 2 or more children set to have their own plan elections, separate from the parent(s). Health insurance carriers require that each child be enrolled in their own individual health plan if they are not grouped as a dependent under a parent. This is true even when enrolled in the same plan. Please keep in mind that this will also result in individual (per person) deductibles and out-of-pocket maximums for each child.`
